import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { WarehouseZones } from "@msuite/utils/types";
import { client } from "@/hono";

export function useWarehouseZones() {
	/** Query */
	const query = useQuery({
		queryKey: ["warehouse-zones"],
		queryFn: async () => {
			const response = await client.stock["warehouse-zones"].$get();
			const data = await responseHandler(response);
			return data.warehouseZones as WarehouseZones;
		},
	});

	/** Return */
	return { ...query, warehouseZones: (query.data || []) as WarehouseZones };
}
